<template>
	<c-dialog ref="dialog" width="800" height="550">
		<c-form ref="importForm" unit-width="100%">
				<c-form-column>
					<c-form-item>
						<c-steps :steps="steps" :active="active" gap="200"></c-steps>
					</c-form-item>

					<c-form-item v-if="active == 2 && importTypeName && importTypeName.length > 1" :label="false">
						<c-radio-group name="import_type" :options="importTypeName" v-model="import_type"></c-radio-group>
					</c-form-item>

					<div v-if="active == 1">
						<div class="import-steps">
							<h5>1. 下载导入模板</h5>
							<p>·请按照模板中的列头批注说明填写完善表格中的内容。<c-link @click="downloadTemplate()">下载模板点击这里</c-link></p>
							<p>·下载模板后，请按<c-link @click="showNoticeMsg()">导入说明</c-link>照填写完善表格中的内容。</p>
							<p>·当上传的表格有多个Sheet时，只导入第一个Sheet的数据。</p>
						</div>
					</div>

					<div v-if="active == 1">
						<div class="import-steps">
							<h5>2. 上传完善好的表格</h5>
							<p>·仅支持上传Excel文件(Excel2007及以上版本)，导入文件最大不超过5MB，数据不超过1000行。</p>
							<c-button size="upload" prepend-icon="c-icon-upload" style="margin-top: 10px;" @click="uploadHandle">点击上传</c-button>
						</div>
					</div>
					<div v-if="active == 2">
						<div class="import-steps">
							<p>1、 带<b style="margin: 0 5px; color: #f00;">*</b>的数据必须填写（选择对应的Excel表头；或者填写默认数据值）。</p>
							<p>2、 导入数据会优先从Excel数据列中取值，如果对应的单元格数据为空，将使用【默认数据】中填写的值进行填充。</p>
						</div>
					</div>

					<div v-if="active == 2">
						<c-table ref="table" :data="matchColumnList" height="320" border :paging="false">
							<c-table-column :label="'系统字段 (共 '+sysColumnTotal+' 列)'" width="180" fixed="left">
								<template #default="{data}">
									<div class="flex-left">
										{{data.system_column_name}}
										<b v-if="data.required==1" style="margin-left: 5px; font-size: 14px; color: #f00;">*</b>
									</div>
								</template>
							</c-table-column>
							<c-table-column :label="'Excel表头 (共 '+excelColumnTotal+' 列)'" width="250">
								<template #default="{data}">
									<c-select name="excel_column_name" :options="excelColumnOptions" v-model="data.excel_column_name"></c-select>
								</template>
							</c-table-column>
							<c-table-column label="默认数据" width="160">
								<template #default="{data}">
									<c-input v-if="data.field_type == 2"
										type="number"
										step="1"
										step-controls="side"
										name="column_default_value"
										v-model="data.column_default_value"
										:range="[0,99999999]"
										decimal="6"
										:placeholder="'请输入'||data.system_column_name"
									></c-input>

									<c-input v-else-if="data.is_custom == 1 && data.config_json.type == 'number'"
										type="number"
										step="1"
										step-controls="side"
										name="column_default_value"
										v-model="data.column_default_value"
										:range="[0,99999999]"
										:decimal="data.config_json.attr.includes('decimal') ? data.config_json.decimal : 0"
										:placeholder="'请输入'||data.system_column_name"
									></c-input>

									<c-datetime v-else-if="data.is_custom == 1 && data.config_json.type == 'time'"
										name="column_default_value"
										v-model="data.column_default_value"
										:type="data.config_json.format.split('|')[1]"
										:format="data.config_json.format.split('|')[0]"
										:time-accuracy="data.config_json.format.split('|')[2]"
										:placeholder="'请选择'||data.system_column_name"
									></c-datetime>

									<template v-else-if="data.is_custom == 1 && data.config_json.type == 'option'">
										<c-select
											search
											name="column_default_value"
											v-model="data.column_default_value"
											:options="data.config_json.options"
											:multiple="data.config_json.attr.includes('multiple')"
											:placeholder="'请选择'||data.system_column_name"
										></c-select>
									</template>

									<template v-else-if="data.is_custom == 0 && data.field_type == 4">
										<c-select
											search
											name="column_default_value"
											v-model="data.column_default_value"
											:options="data.options"
											:placeholder="'请选择'||data.system_column_name"
										></c-select>
									</template>

									<c-input v-else
										type="text"
										name="column_default_value"
										v-model="data.column_default_value"
										:placeholder="'请输入'||data.system_column_name"
									></c-input>
								</template>
							</c-table-column>
						</c-table>
					</div>

					<div v-if="active == 3">
						<div class="import-fruit flex-column flex-center">
							<h1>导入结果</h1>
							<p>批量导入{{this.importResult.total_count}}条数据；成功：<b style="color: green">{{this.importResult.success_count}}条</b>；失败：<b style="color: red">{{this.importResult.fail_count}}条</b>
								<c-link v-if="this.importResult.fail_count > 0 && this.importResult.error_file_url" style="margin-left: 20px;" @click="downloadErrorFile()">下载错误报告</c-link>
							</p>
						</div>
					</div>
				</c-form-column>
		</c-form>

		<template #button>
			<c-button v-if="active == 2" size="dialog" @click="previousStep()">上一步</c-button>
			<c-button v-if="active == 2 && excel_file && !errorFlag" color="main" size="dialog" @click="submit()">确定导入</c-button>
			<c-button v-if="active == 3" size="dialog" @click="previousStep()">继续导入</c-button>
			<c-button v-if="active == 3" color="main" size="dialog" @click="finish()">导入完成</c-button>
		</template>

		<!--提示信息-->
		<c-dialog ref="noticeDialog" width="700" button-name="我知道了" :cancel-button="false">
			<div v-html="noticeMsg" class="import-explain"></div>
		</c-dialog>
	</c-dialog>
</template>

<script>
	import {mapState} from "vuex";
	import dictList from "@/store/dict";

	export default {
		name: 'excelImport',
		props: {
			workType: [String, Number]
		},
		watch: {
		},
		data() {
			return {
				steps:[
					{'name': '上传文件'},
					{'name': '配置表单'},
					{'name': '导入数据'}
				],
				active:1,
				import_type:1,
				excel_file:'',
				matchColumnList:[],
				sysColumnTotal:0,           //系统业务总列数
				excelColumnTotal:0,         //导入Excel总列表
				excelColumnOptions:[],       //导入Excel表头信息（去重）
				importResult:null,
				errorFlag:false,
				warehouse_id:0,
				order_classify:0,
				view_id:0
			}
		},

		computed: {
			// 获取dictName选项数据
			...mapState([]),

			noticeMsg() {

			},

			dialogTitle() {
				return {
					1: '【】',
				}[this.workType]
			},

			importTypeName(){
				let list = [];
				list.push({name: '仅新增数据',value: 1,color: 'black'});
				if (!['1', '3', '6', '39'].includes(this.workType.toString())) {
					list.push(
						{name: '更新和新增数据',value: 2,color: 'blue'}
					);
				}
				return list;
			}
		},

		methods: {
			/************打开新增、编辑弹窗，数据初始化**************/
			open(data) {
				this.import_type = 1;//仅新增
				this.active = 1;//恢复初始值
				this.excel_file = '';
				this.errorFlag = false;
				if (data && data.title){
					this.$refs.dialog.open({
						title: data.title
					});
				}else {
					this.$refs.dialog.open({
						title: '导入'+this.dialogTitle+'数据'
					});
				}
				if (data){
					this.view_id = data.view_id||0;                 //默认视图ID
					this.warehouse_id = data.warehouse_id||0;       //仓库ID
					this.order_classify = data.order_classify||0;   //出入库类型
				}else {
					this.view_id = 0;           //默认视图ID
					this.warehouse_id = 0;      //仓库
					this.order_classify == 0;   //出入库类型
				}
			},

			/*******搜索【仓库】下拉框信息*****************/
			searchWarehouse(keyword, resolve){
				this.request({
					url:'/system/options',
					data: {
						options_code:'WAREHOUSE',
						keyword:keyword
					},
					success:data => {
						resolve(data);
					}
				})
			},

			/*****************下载导出模板**********************/
			downloadTemplate(){
				this.request({
					url: '/import/url',
					data:{
						work_type:this.workType,
						view_id:this.view_id
					},
					success: data => {
						this.download({
							fileName: data.filename,
							url: data.url,
							loading: {
								message: '数据文件生成中...'
							}
						});
					}
				});
			},

			/*****************展示导入说明数据**********************/
			showNoticeMsg(){
				this.$refs.noticeDialog.open({
					title:'导入说明'
				});
			},

			/*****************上传文件**********************/
			uploadHandle() {
				this.uploadConfig({
					folder: 'temporary'
				})
				this.$upload({
					type: 'excel',
					size: 5120,
					loading: true,
					success: data => {
						this.excel_file = data[0].path;
						this.analysisUploadFile();
					}
				});
			},

			/*****************解析上传成功的Excel文件**********************/
			analysisUploadFile() {
				this.request({
					url: '/import/analysis/excel/head',
					data: {
						work_type: this.workType,
						view_id: this.view_id,
						url: this.excel_file
					},
					loading: {
						message: '文件上传解析中...'
					},
					success: data => {
						this.errorFlag = false;
						this.matchColumnList = data.matchColumnList || [];
						this.matchColumnList.map(field => {
							if (field.is_custom == 0 && field.field_type == 4) {
								if (field.config_json.dict_config.dictType == 'PAGEDIC') {
									var optionsList = dictList[field.config_json.dict_config.dictName].map(item => {
										var obj = {};
										obj.value = item.name;
										obj.name = item.name;
										return obj;
									});
									this.$set(field, 'options',optionsList);
								} else if (field.config_json.dict_config.dictType == 'DBDIC') {
									this.request({
										url:'/system/options',
										data: {
											options_code:field.config_json.dict_config.dictName
										},
										success:data => {
											var optionsList = data.map(item => {
												var obj = {};
												var name = item.name;
												//客户
												if ('CUSTOMER'== field.config_json.dict_config.dictName){
													name = item.data.customer_name;
												//不良品项
												}else if ('DICDEFECTS'== field.config_json.dict_config.dictName){
													name = item.data.defects_name;
												//工序
												}else if ('DICPROCESS'== field.config_json.dict_config.dictName){
													name = item.data.process_name;
												//工艺路线
												}else if ('PROCESSROUTE'== field.config_json.dict_config.dictName){
													name = item.data.route_name;
												//供应商
												}else if ('SUPPLIER'== field.config_json.dict_config.dictName){
													name = item.data.supplier_name;
												//仓库
												}else if ('WAREHOUSE'== field.config_json.dict_config.dictName){
													name = item.data.warehouse_name;
												}
												
												obj.value = name;
												obj.name = name;
												return obj;
											});
											this.$set(field, 'options', optionsList);
										}
									});
								}
							}
							field.column_default_value = '';
						});
						this.sysColumnTotal = data.sysColumnTotal || 0;
						this.excelColumnTotal = data.excelColumnTotal || 0;
						this.excelColumnOptions = data.excelColumnOptions || [];
						setTimeout(() => {
							this.active = 2;//上传文件完成，跳转配置表单页面
						}, 500);
					},
					fail: () => {
						this.errorFlag = true;
					}
				});
			},

			//回退至上一步
			previousStep(){
				this.active = 1;
			},

			//完成
			finish(){
				this.$refs.dialog.close();
			},
			/************下载错误文件************/
			//
			submit(){
				//判断【必填】项是否已填写
				var submitFlag = true;
				this.matchColumnList.forEach(item => {
					if (item.required==1
						&& (!item.excel_column_name || item.excel_column_name == '')
						&& (!item.column_default_value || item.column_default_value == '')
					){
						submitFlag = false;
						this.$message({
							message: '请完善所有带星号的【必填】数据列',  // 提示内容,
							type: 'warn'
						});
						return;
					}
				});
				if (submitFlag){
					this.request({
						url: '/import/analysis/excel/data',
						data: {
							work_type:this.workType,
							view_id:this.view_id,
							url: this.excel_file,
							match_column_list: this.matchColumnList,
							import_type: this.import_type,
							warehouse_id: this.warehouse_id,
							order_classify: this.order_classify
						},
						loading: {
							message: '导入数据处理中...'
						},
						success: data => {
							this.errorFlag = false;
							this.importResult = data;
							setTimeout(() => {
								this.active = 3;//恢复初始值
								//执行回调方法
								this.$emit('resolve');
							}, 500);
						},
						fail: () => {
							this.errorFlag = true;
						}
					});
				}
			},

			/************下载错误文件************/
			downloadErrorFile() {
				this.download({
					fileName: this.importResult.error_file_name,
					url: this.importResult.error_file_url,
					loading: {
						message: '数据文件生成中...'
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.import-steps {
		padding: 10px 20px;
		background-color: #F8F8F8;

		h5 {
			line-height: 36px;
			font-size: 15px;
		}

		p {
			padding: 4px 0;
			line-height: 20px;
			color: #666;
		}
	}

	.import-explain {
		padding: 20px;

		>>> p {
			padding: 4px 0;
			line-height: 20px;
		}
	}

	.import-fruit {
		height: 200px;
		background-color: #F8F8F8;

		h1 {
			margin-bottom: 30px;
			font-size: 26px;
		}
	}
</style>